import React from 'react';

function ThankYouPage() {
  return (
    <div className="thank-you-container" style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Thank You!</h1>
      <p>Your feedback has been submitted successfully.</p>
    </div>
  );
}

export default ThankYouPage;
